/**
 * React Query Client 설정
 *
 * 전역 캐싱 및 데이터 fetching 전략 관리
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 5분간 데이터를 fresh로 간주 (재요청하지 않음)
      staleTime: 5 * 60 * 1000,

      // 10분간 캐시 유지
      gcTime: 10 * 60 * 1000,

      // 에러 발생 시 재시도
      retry: 1,

      // 윈도우 포커스 시 자동 재검증 비활성화 (찬송가 데이터는 자주 변경되지 않음)
      refetchOnWindowFocus: false,

      // 네트워크 재연결 시 재검증
      refetchOnReconnect: true,
    },
  },
});
